import { render } from "./MainSlider.vue?vue&type=template&id=6d04a4ee&scoped=true"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"

import "./MainSlider.vue?vue&type=style&index=0&id=6d04a4ee&lang=scss"
import "./MainSlider.vue?vue&type=style&index=1&id=6d04a4ee&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d04a4ee"]])

export default __exports__